var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    viewBox: "0 0 52 34",
    width: 52,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h52v34h-52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2440.184 993.416a4.438 4.438 0 1 1 -4.438 4.438 4.437 4.437 0 0 1 4.438-4.438zm14.521 0a4.438 4.438 0 1 1 -4.438 4.438 4.438 4.438 0 0 1 4.438-4.438zm-14.521 4.44 3.992-5.112 7.348-.744m1.217-2.07-2.068.148 4.029 7.773m-12.51-7.2h2.568",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(-2421.746 -978.931)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.06e46005111893e321a23b0fec439e6e.svg";
export { ForwardRef as ReactComponent };